module.exports = __webpack_public_path__ + "media/images/icon__live-169cb4eadf7bf5a060183f6b7bc45f89.png";